export default __webpack_public_path__ + "static/media/rentcafe.e471e70b.png";